import React from "react";
import { render } from "react-dom";
import { Dashboard } from "vrcore-dashboard";
import firebaseConfig from "./config/firebase";
import pagesConfig from "./config/pages";
import profileConfig from "./config/profile";
import reportsConfig from "./config/reports";

const App = () => (
    <Dashboard
        firebaseConfig={firebaseConfig}
        pagesConfig={pagesConfig}
        profileConfig={profileConfig}
        reportsConfig={reportsConfig}
    />
);

render(<App />, document.getElementById("root"));
